import { TrainInfoModel } from "../../store/TrainManageStore"
import { CloseBtn } from "../CloseBtn/CloseBtn";
import { Input, Select, InputNumber } from "antd";
import "./PublishModel.less"
import { useState } from "react";
import Images from "../../utils/Images";

type PublishModelProps = {
    model: TrainInfoModel;
    onClose: () => void;
};

const MAX_TITLE_LEN = 30;

const baseModelOptions = [
    {label: "云墨大模型", value: "云墨大模型"}
];

const modelTypeOptions = [
    {label: "LoRA", value: "LoRA"}
];

const modelCategoryOptions = [
    {label: "通用", value: "通用"}
];

const samplerOptions = [
    {label: "Restart", value: "Restart"}
];

const clamp = (a: number, min: number, max: number): number => {
    return Math.min(max, Math.max(min, a));
};

const suffix = <img style={{height: "0.12rem"}} src={Images.expand}></img>;

export const PublishModel = (props: PublishModelProps): React.ReactElement => {
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [baseModel, setBaseModel] = useState(baseModelOptions[0].value); // 基础模型
    const [modelType, setModelType] = useState([modelTypeOptions[0].value]); // 模型类型
    const [modelCategory, setModelCategory] = useState(modelCategoryOptions[0].value); //模型分类
    const [sampler, setSampler] = useState(samplerOptions[0].value); // 采样方法
    const [trigger, setTrigger] = useState(props.model.trigger); // 触发词
    const [weight, setWeight] = useState(0.7); // 建议权重
    const [step, setStep] = useState(20); // 迭代步数
    const [cfg, setCFG] = useState(5); // 描述词引导系数

    const params: any[][] = [
        ["基础模型", baseModel, setBaseModel, baseModelOptions],
        ["模型类型", modelType, setModelType, modelTypeOptions],
        ["模型分类", modelCategory, setModelCategory, modelCategoryOptions],
        ["触发词", trigger, setTrigger],
        ["建议权重", weight, setWeight, 0, 2, 0.01],
        ["采样方法", sampler, setSampler, samplerOptions],
        ["迭代步数", step, setStep, 1, 100, 1],
        ["描述词引导系数", cfg, setCFG, 1, 100, 1]
    ];

    const onTitleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
        setTitle(e.target.value.slice(0, MAX_TITLE_LEN));
    };

    const createInput = (item: any): React.ReactElement => {
        if(Array.isArray(item[3])){
            return <Select value={item[1]} onChange={item[2]} options={item[3]} suffixIcon={suffix}></Select>;
        }
        if(typeof item[1] === "string"){
            return <div className="publish-model-content-params-input-wrap">
                <Input variant="borderless" className="publish-model-input" value={item[1]} onChange={item[2]}></Input>
            </div>;
        }

        return <div className="publish-model-content-params-input-wrap">
            <InputNumber type="number" variant="borderless" className="publish-model-input" value={item[1]} onChange={item[2]} min={item[3]} max={item[4]} step={item[5]} controls={false}></InputNumber>
            <div className="publish-model-add-num">
                <img src={Images.expand} onClick={() => (item[2])(clamp(item[1] + item[5], item[3], item[4]))}></img>
                <img src={Images.expand} onClick={() => (item[2])(clamp(item[1] - item[5], item[3], item[4]))}></img>
            </div>
        </div>;
    };

    return <div className="fullscreen-dialog-bg-color fullscreen-mask">
        <div className="publish-model">
            <CloseBtn onClick={props.onClose}></CloseBtn>
            <div className="publish-model-title">发布模型</div>
            <div className="publish-model-content no-scrollbar">
                <span className="publish-model-content-label">模型名称</span>
                <div className="publish-model-title-input-wrap">
                    <Input className="publish-model-input" variant="borderless" value={title} onChange={onTitleChange} placeholder="请输入模型名称"></Input>
                    <span>{title.length}/{MAX_TITLE_LEN}</span>
                </div>
                <span className="publish-model-content-label">模型介绍</span>
                <div className="publish-model-descrition-input-wrap">
                    <Input.TextArea className="publish-model-input" style={{resize:"none"}} value={description} onChange={e => setDescription(e.target.value)} variant="borderless" placeholder="请输入模型介绍"></Input.TextArea>
                </div>
                <span className="publish-model-content-label">模型文件</span>
                <div className="publish-model-content-model-name">{props.model.name}</div>
                <div className="publish-model-content-params">
                    {params.map((item, i) => <div key={i} className="publish-model-content-params-item">
                        <span className="publish-model-content-label">{item[0]}</span>
                        {createInput(item)}
                    </div>)}
                </div>
                <span className="publish-model-content-label">模型预览图</span>
                <div className="publish-model-preview" style={{"--img": `url(${props.model.cover})`} as React.CSSProperties}></div>
                <div className="publish-model-confirm-btn">
                    <img src={Images.publish}></img>
                    <span>发布</span>
                </div>
            </div>
        </div>
    </div>;
};